export default "__VITE_ASSET__CcDP5zsD__"